import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { useSnackbar } from "notistack";

import { appClearMessages } from "@/store/app";

const AppNotifications: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  
  const { messages } = useAppSelector((state) => state.app);

  useEffect(() => {
    if (messages.length) {
      for (const message of messages) {
        enqueueSnackbar(message.text, {
          variant: message.type || "default",
          autoHideDuration: 2500,
          anchorOrigin: { vertical: "top", horizontal: "right" },
          preventDuplicate: true,
        });
      }
      dispatch(appClearMessages());
    }
  }, [messages, enqueueSnackbar, dispatch]);

  return null; // Clean return with no JSX
};

export default AppNotifications;